import Location from '../../components/gmaps-location';

(() => {
  const selectors = {
    btnTalkRealtor: ' .cta-talk-realtor',
  }

  Array.prototype.slice
    .call(document.querySelectorAll(selectors.btnTalkRealtor))
    .map(item => {
      item.addEventListener('click', function (evt) {
        evt.preventDefault();
        window.location = '/contato?productId=' + hypnoboxId;
        // const origin = evt.currentTarget.dataset.origin;
        // const modal = new TalkRealtor(origin);
        // modal.openModal();
      });
    });

  if (activeLocation === 1) {
    const map = document.querySelector('#map .txt-map');

    if (map != null) {
      document.querySelector('#map .txt-map').addEventListener('click', function () {
        new Location();
      });
    }

    if (document.querySelector('#origin-input')) {
      document.querySelector('#origin-input').addEventListener('focus', function () {
        new Location();
      });
    }
  }
  setTimeout(function () {
    let uls = ["imageSlideShowDecorado", "imageSlideShowFotosIlustradas", "imageSlideShowPlantas", "imageSlideShowPronto"]
    for (let index = 0; index < uls.length; index++) {
      loadSlideShow(uls[index])
    }
  }, 1500)

  function loadSlideShow(ulName) {
    let ul = document.getElementById(ulName);
    if (ul != undefined) {
      if (ul.children != undefined) {
        let lis = ul.querySelectorAll("li");
        let totalLis = lis.length;
        lis.forEach(li => li.style.width = (95 / totalLis) + "%");
      }
    }
  }

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        (rect.top - 20) >= 0 &&
        rect.left >= 0 &&
        (rect.bottom - 20) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function showWhatsapp(){
    let elBoxContactDesktop = document.querySelector('.box-info-house');
    let elContactMobile = document.querySelector('#box-info-mobile');
    let btnWhats = document.querySelector('.imovel-whats');

    if(isInViewport(elBoxContactDesktop) || isInViewport(elContactMobile)){
      btnWhats.style.opacity = 0;
      btnWhats.style.visibility = 'hidden';
    } else {
      btnWhats.style.opacity = 1;
      btnWhats.style.visibility = 'visible';
    }
  }

  window.onscroll = () => {
    showWhatsapp();
  }
  
  showWhatsapp();

})();